import { getImageAsset } from '@acorns/web-utils'

import type { BlueprintAsset } from '@/grove-blueprints/generated-types'

function toKebabCase(name: string): string {
  return name.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`)
}

// @ts-ignore: require.context is a webpack-specific API.
const blueprintLocalImages = require.context(
  '../../../../../public/images/blueprint',
  false,
  /\.svg$/,
)

const blueprintImageMap: Record<string, string> = {}

for (const key of blueprintLocalImages.keys()) {
  blueprintImageMap[key.replace('./', '')] = blueprintLocalImages(key)
}

export function resolveAssetSource(asset: BlueprintAsset): string {
  switch (asset.type) {
    case 'local': {
      const filename = `${toKebabCase(asset.name)}.svg`
      return blueprintImageMap[filename] ?? ''
    }
    case 'remote': {
      return getImageAsset(asset.path, 'svg').url
    }
    default: {
      return ''
    }
  }
}
